import '../styles/Carousel.css';
import {useEffect, useRef, useState} from "react";

export enum CarouselDirection {
    Vertical = "vertical",
    VerticalReverse = "vertical reverse",
    Horizontal = "horizontal"
}
let startX = 0;
let startMoveX = 0;
const minScroll = -50;
export function Carousel( {items, ...props} ) {
    const [scrollLeft, setScrollLeft] = useState(items.direction === CarouselDirection.Horizontal ? minScroll : 0);
    const [moveLeft, setMoveLeft] = useState(0);

    const carouselRef = useRef(null);

    useEffect(() => {
        if(props.direction === CarouselDirection.Horizontal) {
            const handleScroll = (e) => {console.log(e);
                setScrollLeft((window.scrollY / 2) - 50);
            };

            window.addEventListener('scroll', handleScroll);

            return () => {
                window.removeEventListener('scroll', handleScroll);
            };
        }
    }, []);

    function onMouseDown(e) {
        e.preventDefault();

        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);

        startX      = e.clientX;
        startMoveX  = moveLeft;
    }

    function onMouseMove(e) {
        if(props.direction === CarouselDirection.Horizontal) {
            const diff = e.clientX - startX;
            let newMoveLeft = startMoveX - diff;
            const bbox = carouselRef.current.getBoundingClientRect();
            const maxWidth = items.length * (483 + 50) - bbox.width;

            newMoveLeft = Math.max(0, Math.min(newMoveLeft, maxWidth));

            setMoveLeft(newMoveLeft);
        }
    }

    function onMouseUp() {
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
    }


    let currentScroll = (scrollLeft + moveLeft);

    if(currentScroll < minScroll) {
        currentScroll = minScroll;
    }

    let doubleItems = items.concat(items).concat(items);

    const handleScroll = props.direction === CarouselDirection.Horizontal;
    return (
        <div className={"carousel-wrapper " + props.direction}>
            <div className="carousel"
                 style={handleScroll ? {transform: "translateX(" + (-1 * currentScroll) + "px)"} : undefined}
                 onMouseDown={handleScroll ? onMouseDown : undefined}
                 ref={carouselRef}
            >
                <div className="group">
                    {items.map((item, index) => (
                        <div key={index} className="carousel-item">
                            {item}
                        </div>
                    ))}
                </div>
                <div aria-hidden className="group">
                    {items.map((item, index) => (
                        <div key={index + "_2"} className="carousel-item">
                            {item}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
